export const getEnumValues = (object: object) =>
  Object.keys(object).filter((item) => {
    return isNaN(Number(item));
  });